import { ModelViewer, Input, Select, Modal, LegacyPage } from 'peach/components'
import { useHasPermission } from 'peach/hooks'
import { useParams } from 'peach/router'

import { Warning } from 'core/errors/DefaultFallback'
import { useLoanActivate, useLoanGet, useLoanUpdate } from 'core/types'

const LoanBasics = () => {
  const { personId, loanId } = useParams<{
    personId?: string
    loanId?: string
  }>()

  const { data: loan, refetch: refetchLoan } = useLoanGet({
    personId,
    loanId,
  })

  const { mutateAsync: updateLoan } = useLoanUpdate({
    personId,
    loanId,
  })

  const { mutateAsync: activateLoan } = useLoanActivate({
    personId,
    loanId,
  })

  const {
    status,
    type,
    assetDisplayName = '[No assetDisplayName provided]',
  } = loan ?? {}

  const sendEditLoan = async (newLoan, diff) => {
    console.info({ newLoan, diff })

    await updateLoan({
      ...diff,
      query: { validate: false },
    })
  }

  const sendActivateLoan = async (activationOptions) => {
    const { status } = loan ?? {}

    if (status === 'pending') {
      await updateLoan(
        {
          status: 'originated',
        },
        {
          query: { validate: false },
        },
      )
    }

    await activateLoan(activationOptions)
    await refetchLoan()
  }

  const amortizationOptions = [
    'expectedPaymentsAtOrigination',
    'amortizeAtActivation',
  ]

  const initialOptions = {
    amortizationAtActivation: 'amortizeAtActivation',
  }

  const activateInstallmentLoan = (
    <Modal
      disabled={status === 'active'}
      initialValue={initialOptions}
      onSubmit={sendActivateLoan}
      title='Activate Installment Loan'
    >
      <Select
        formKey='amortizationAtActivation'
        nullable
        options={amortizationOptions}
      />
      {loan?.status === 'pending' && (
        <Warning>
          This loan is in a pending status. This action will first set the loan
          to "originated" and then "active"
        </Warning>
      )}
    </Modal>
  )

  const activateLineOfCredit = (
    <Modal
      disabled={status === 'active'}
      initialValue={{}}
      onSubmit={sendActivateLoan}
      title='Activate Line of Credit'
    />
  )

  const hasPermission = useHasPermission('loan:update.force')

  const activationModal =
    type === 'installment'
      ? activateInstallmentLoan
      : type === 'lineOfCredit'
      ? activateLineOfCredit
      : null

  return (
    <LegacyPage.Full>
      {activationModal}
      <Modal
        initialValue={loan}
        onSubmit={sendEditLoan}
        title={`Edit ${assetDisplayName}`}
      >
        <Input formKey='nickname' />
        <Input
          disabled={!hasPermission}
          formKey='externalId'
          note={`requires 'loan:update.force' permission`}
          nullable
        />
        {/* <LoanStatusSelect formKey='status' /> */}
      </Modal>
      <ModelViewer json={loan} />
    </LegacyPage.Full>
  )
}

export default LoanBasics
